import { createAction, props } from "@ngrx/store";
import { SignInStore } from "../interfaces/sign-in-store.interface";
import { RelativeNavigation } from "@nx/mono-common";
import { ClientMetadata } from "libs/auth/src/lib/interfaces/client-meta-data.interface";


export const UpdateSignInStoreAction = "[Sign In] Update Sign In Store";
export const UpdateSignInStore = createAction(
  UpdateSignInStoreAction,
  props<{ updatedSignIn: SignInStore, signInAttribute?: string, relativeNavigation?: RelativeNavigation }>());

export const UpdatingSignInStore = createAction(
  "[Sign In] Updating Sign In Store",
  props<{ pending: boolean }>());

export const UpdateSignInStoreSuccessAction = "[Sign In] Update Sign In Store Success";
export const UpdateSignInStoreSuccess = createAction(
  UpdateSignInStoreSuccessAction,
  props<{ updatedSignIn: SignInStore, relativeNavigation?: RelativeNavigation }>());

export const UpdateSignInStoreErrorAction = "[Sign In] Update Sign In Store Error";
export const UpdateSignInStoreError = createAction(
  UpdateSignInStoreErrorAction,
  props<{ error: Error }>());

export const UpdateSignInStoreUserUnverifiedViaLMWErrorAction = "[Sign In] Update Sign In Store User Unverified Via LMW Error";
export const UpdateSignInStoreUserUnverifiedViaLMWError = createAction(UpdateSignInStoreUserUnverifiedViaLMWErrorAction, props<{ updatedSignIn: SignInStore }>());
export const UpdateSignInStoreUserUnverifiedViaOCNErrorAction = "[Sign In] Update Sign In Store User Unverified Via OCN Error";
export const UpdateSignInStoreUserUnverifiedViaOCNError = createAction(UpdateSignInStoreUserUnverifiedViaOCNErrorAction, props<{ updatedSignIn: SignInStore }>());

export const UserUnverifiedViaLMWErrorAction = "[Sign In] User Unverified Via LMW Error";
export const UserUnverifiedViaLMWError = createAction(UserUnverifiedViaLMWErrorAction);
export const UserUnverifiedViaOCNErrorAction = "[Sign In] User Unverified Via OCN Error";
export const UserUnverifiedViaOCNError = createAction(UserUnverifiedViaOCNErrorAction);

export const UserNotLmwRegisteredErrorAction = "[Sign In] User Not Lmw Registered Error";
export const UserNotLmwRegisteredError = createAction(UserNotLmwRegisteredErrorAction);

export const SignInUser = createAction(
  "[Sign In] Sign In User",
  props<{ signInAttribute: string, password: string, clientMetaData?: ClientMetadata }>());

export const SigningInUser = createAction(
  "[Sign In] Signing in user",
  props<{ pending: boolean }>());

export const SignInUserSuccess = createAction("[Sign In] Sign In User Success");

export const SignInUserErrorAction = "[Sign In] Update Sign In User Error";
export const SignInUserError = createAction(
  SignInUserErrorAction,
  props<{ error: Error }>());

export const SignInDestroyAction = "[Sign In] Sign In Destroy State";
export const SignInDestroy = createAction(SignInDestroyAction);
